import { ApiResponseV2 } from "@vertical-insure/shared";
import {DynamicHtmlElement} from "@/components/ui/DynamicHtmlElement";
import {ProductDescriptors} from "@/components/ui/ProductDescriptors";
import {AcceptAction} from "@/components/ui/AcceptAction";
import {formatCents} from "@/lib/utils";
import {DeclineAction} from "@/components/ui/DeclineAction";
import {FormError} from "@/components/ui/FormError";

export const MultiDecisionLayout = ({quote}: {quote: ApiResponseV2}) => {

  return quote.decisions?.length > 0 && (
    <>
      {quote.decisions
        ?.filter(decision => decision.options.some(option => option.status === 'success'))
        ?.map((decision, decisionIndex) => {
        return (
          <div key={decisionIndex} className="space-y-2">
            {decision.options.filter(option => option.status === 'success').map((option, index) => {
              return option.data ? (
                <div className="flex flex-1 flex-col border p-2 rounded gap-2" key={index}>
                  <AcceptAction type="radio" quoteId={option.data.quote_id} className={"border-0"} decisionIndex={decisionIndex}>
                    <div>
                      <DynamicHtmlElement html={option.data.product.promotional_header} className="text-md font-semibold" />
                      <div className="text-sm">
                        one-time fee of <span className="font-medium underline decoration-dashed underline-offset-4">{formatCents(option.data.total, option.data.currency)}</span>
                      </div>
                    </div>
                  </AcceptAction>
                  <DynamicHtmlElement html={option.data.product.promotional_description} className="text-sm" />
                  <ProductDescriptors descriptors={option.data.product.descriptors ?? option.data.product.perils} className={"md:columns-2"} />
                  <DynamicHtmlElement html={option.data.product.legal_disclaimer} className="text-xs mt-2" />
                </div>
              ) : null;
            })}
            <DeclineAction type="radio" decisionIndex={decisionIndex}/>
          </div>
        );
      })}
      <FormError />
    </>
  )
}
